<template>
	<div :class="{ 'nk-form-separator': true, 'has-title': hasTitle }">
		<div v-if="hasTitle" class="sep-title" v-html="title"></div>
	</div>
</template>
<script>
	export default {
		props: {
			title: { type: String }
		},
		computed: {
			hasTitle() {
				return this.title && this.title.length > 0
			}
		}
	}
</script>
